import React from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useSpring } from "framer-motion";
import Logo from "./Logo.js";

const Nav = ({ minimal = false }) => {
  const { scrollYProgress } = useScroll();
  const progress = useSpring(scrollYProgress, { stiffness: 120, damping: 30 });

  return (
    <header className="nav">
      <div className="nav-inner">
        <Link to="/" className="brand" aria-label="Meck Interactive home">
          <Logo size={34} />
          <span className="brand-text">
            MECK<span className="brand-dim">INTERACTIVE</span>
          </span>
        </Link>
        {!minimal && (
          <nav className="nav-links">
            <a href="#apps">Apps</a>
            <a href="#studio">Studio</a>
            <a href="#contact">Contact</a>
          </nav>
        )}
        <a href="mailto:app@meck-int.com" className="btn btn-small">
          Get in touch
        </a>
      </div>
      <motion.div className="nav-progress" style={{ scaleX: progress }} />
    </header>
  );
};

export default Nav;
